import {
  HumanInTheLoopProvider,
  type HumanInTheLoopContextValue,
} from "./HumanInTheLoopContext";
import {
  ToolApprovalProvider,
  type ToolApprovalPresentation,
} from "./ToolApproval";
import { ToolCallBlock } from "./messages/ToolCallBlock";

export const HumanInTheLoopReview = ({
  value,
  approvals,
  actionIndex,
}: {
  value: HumanInTheLoopContextValue;
  approvals: ToolApprovalPresentation[];
  actionIndex?: number;
}) => (
  <HumanInTheLoopProvider value={value}>
    <div className="flex flex-col gap-2" aria-label="Pending tool reviews">
      {value.request.action_requests.map((action, index) =>
        actionIndex === undefined || actionIndex === index ? (
          <ToolApprovalProvider
            key={`${index}-${action.name}`}
            value={approvals[index]}
          >
            <ToolCallBlock
              toolCall={{
                type: "tool_call",
                name: action.name,
                args: action.args,
              }}
              humanInTheLoopActionIndex={index}
            />
          </ToolApprovalProvider>
        ) : null
      )}
    </div>
  </HumanInTheLoopProvider>
);
export default HumanInTheLoopReview;
